import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_ade_sr_web_genius_sorting",
  stages: {},
  defaultStage: 1,
  goals: {
    booked_with_deals_sorting: 1,
    sr_offer_position_1_click: 2,
    sr_offer_position_2_to_5_click: 3
  }
});

export default utils;
